import DOMPurify from "dompurify";

/**
 * Returns a props object suitable for React's dangerouslySetInnerHTML,
 * with the input HTML sanitized via DOMPurify to prevent XSS.
 *
 * Usage: <div dangerouslySetInnerHTML={safeHtml(article.body_rich_text)} />
 */
export function safeHtml(html) {
  return { __html: DOMPurify.sanitize(html || "") };
}
